import { mapLiveDashboardRowToLeagueGame } from '../api';
import { isQualifiedMainGame } from '../components/LiveLeagueGamesCard';
import type { LscLiveDashboardRow } from '../types';

/**
 * Member home live games. `auto_show_verified_live_games` is already applied
 * inside `member_visible_rows`. Commissioner `rows` stay off this surface.
 */
export function selectMemberHomeLiveRows(dashboard: {
  rows?: LscLiveDashboardRow[] | null;
  member_visible_rows?: LscLiveDashboardRow[] | null;
}): LscLiveDashboardRow[] {
  return (dashboard.member_visible_rows ?? []).filter((row) =>
    isQualifiedMainGame(mapLiveDashboardRowToLeagueGame(row))
  );
}
